import React, { useState, useEffect, useCallback, useRef, useContext } from "react";
import { Popover, message, Tooltip } from "antd";
import { useHistory } from "react-router-dom";
import Icon from "../../../Icon";
import "./index.less";
import events from "../../../context/events";
import { connect } from "dvajs";
import { JoyspaceState, FolderInfoRes } from "@/models/joyspace";
import {
  getJoySpaceReadOnlyPermission,
  folderTypeEnum,
  getJoySpaceReadFolderPermission
} from "../../../config/permissions.config";
import Api from "../../../api";
import openFolderModal from "../../../contextModal/FolderModal";
import GlobalContext from "@/context/GlobalContext";
import { OpenFolderStatus } from "../../../types";
import { Order, Sort } from "../../../components/List/Filters/config";
import ShareIcon from "../../../components/List/ShareIcon";
export interface IProps {
  folderId: string; // 当前文件夹的ID
  setFolder: Function;
  folderInfoMap: any;
  changeFolderInfoById: Function;
  _filterInfo: any;
  gname: string;
}

interface IPath {
  id: string;
  name: string;
  url?: string;
  description?: string;
  permissionsType?: number; // (权限类型. 1-读写 2-只读)
  isRoot?: boolean; // (是否是根级目录)
  isLast?: boolean; // (是否是末级导航)
  isShared: boolean; // 是否分享过文件夹
}

interface Parames {
  fullName: string;
  fullPath: string;
  permissionsType?: number;
  description?: string;
}

let filterInfo: any = {
  srot: Sort.UpDateTime,
  order: Order.DESC
};

let laetId: any = 0;
function SpaceCategoriesPaths(props: IProps) {
  const { folderInfoMap, changeFolderInfoById, folderId, setFolder, _filterInfo, gname } = props;
  filterInfo = _filterInfo;
  const [paths, setPaths] = React.useState<IPath[]>([]);
  const [collapseNavList, setCollapseNav] = React.useState<IPath[]>([]);
  const [disabled, setDisabled] = React.useState(false);
  const { onLine } = useContext(GlobalContext);
  React.useMemo(() => {
    setDisabled(!onLine);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onLine]);

  // 清除router CreatRouterParames
  const onCreatRouterParames = useCallback(
    (id: string) => {
      let list: any = [...paths];
      list.splice(1, 0, [...collapseNavList]);
      let nav = list.flat(); // 拉平数组
      const index = nav.findIndex((item: IPath) => item.id === id);
      if (index !== -1 && index !== nav.length - 1) {
        nav.splice(index + 1, nav.length); // 删除不包含本身的数据的之后的数据
      }
      nav[nav.length - 1].isRoot = nav.length === 2 ? true : false;
      nav[nav.length - 1].isLast = true;
      setCollapseNav(handleCollapseNav(nav));
      setPaths(nav);
    },
    [paths, collapseNavList]
  );
  // 生成router
  const onCreatRouter = useCallback(
    (rootNode: any, parames: FolderInfoRes) => {
      const {
        full_name: fullName = "",
        full_path: fullPath = "",
        permissions,
        description = "",
        created_by = ""
      } = parames || {};
      // console.log(parames, 'paramesparamesparamesparames');
      let pathList: IPath[] = [rootNode];
      if (pathList[0].isLast) {
        setPaths(pathList);
        events.emit("onShowFolderDesc", "");
        return;
      }
      const tmpNavNameList = fullName.split("$@$");
      const navPathList = fullPath.split("$@$");
      const navNameList = navPathList.map((id, index) => {
        return tmpNavNameList[index];
      });
      const navList: IPath[] = navPathList.map((id, index) => {
        return {
          id,
          name: index ? navNameList[index] || "" : gname,
          description,
          permissionsType: getJoySpaceReadFolderPermission(permissions),
          createdId: created_by,
          isRoot: index - 1 ? false : true,
          isLast: index === navPathList.length - 1,
          isShared: false
        };
      });
      events.emit("onShowFolderDesc", navList[navList.length - 1].description);
      setCollapseNav(handleCollapseNav(navList));
      setPaths(navList);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [folderInfoMap, folderId]
  );

  // 获得当前文件夹的信息
  const getFolderInfo = useCallback(async () => {
    return await Api.categories.info(folderId);
  }, [folderId]);

  // 获取导航
  useEffect(() => {
    console.log(folderId, "folderIdfolderIdfolderId====>");
    laetId++;
    const theLastId = laetId;
    getFolderInfo().then((res: any) => {
      if (theLastId === laetId) {
        let rootNode = {
          name: gname,
          isLast: true
        };
        if (res) {
          const { parent } = res;
          rootNode.isLast = !parent;
        }
        onCreatRouter(rootNode, res);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [folderId]);

  // 导航折叠
  const handleCollapseNav = function (list: IPath[]) {
    if (list.length > 4) {
      return list.splice(1, list.length - 3);
    }
    return [];
  };

  // 渲染折叠导航DOM
  const handleRenderCollapseNav = useCallback(() => {
    const content = (
      <div className="joyspace-collapse-nav">
        {collapseNavList.map((path: IPath) => {
          return (
            <a
              key={path?.id}
              onClick={() => {
                events.emit("onShowFolderDesc", path.description);
                events.emit("list.check");
                events.emit("groupspace.setSearchFolderId", path.id);
                setFolder(path);
                // onCreatRouterParames(path?.id);
              }}
            >
              <ShareIcon isShared={gname ? true : path.isShared} />
              {/* <Icon
                                className="joyspace-collapse-nav_file_icon"
                                type="iconapp_btn_file_4"
                            /> */}
              <span className="joyspace-collapse-nav_text joyspace-breadcrumb-ellipsis">
                {path.name}
              </span>
            </a>
          );
        })}
      </div>
    );
    return (
      <Popover
        overlayClassName="joyspace-collapse-nav_popover"
        content={content}
        title={null}
        trigger="hover"
      >
        <span style={{ color: "#999999", cursor: "pointer" }}>...</span>
      </Popover>
    );
  }, [collapseNavList, setFolder, gname]);
  // 渲染主体
  if (paths.length === 1) {
    return (
      <div className="joyspace-breadcrumb-container">
        <div className="joyspace-breadcrumb">
          <div className="joyspace-breadcrumb-ellipsis1">{paths[0].name}</div>
        </div>
      </div>
    );
  }
  return paths.length ? (
    <div className="joyspace-breadcrumb-container">
      {/* 导航 */}
      <div className="joyspace-breadcrumb">
        {paths.map((path, index) => {
          return (
            <React.Fragment key={path.id}>
              {/* 箭头 */}
              {index !== 0 && (
                <Icon
                  className={
                    path.isLast ? "breadcrumb-icon breadcrumb-last-nav" : "breadcrumb-icon"
                  }
                  type="iconwin_right"
                />
              )}
              {/* 折叠的导航 */}
              {index === 1 && collapseNavList.length !== 0 && handleRenderCollapseNav()}
              {index === 1 && collapseNavList.length !== 0 && (
                <Icon
                  className={
                    path.isLast ? "breadcrumb-icon breadcrumb-last-nav" : "breadcrumb-icon"
                  }
                  type="iconwin_right"
                />
              )}
              {/* 末级及次级导航 */}
              <a
                className={
                  path.isLast
                    ? "breadcrumb-link breadcrumb-last-nav joyspace-breadcrumb-ellipsis2"
                    : "breadcrumb-link  joyspace-breadcrumb-ellipsis"
                }
                style={{ overflow: path.isRoot ? "hidden" : "" }}
                title={path.name}
                onClick={() => {
                  onCreatRouterParames(path.id);
                  events.emit("onShowFolderDesc", path.description);
                  events.emit("list.check");
                  events.emit("groupspace.setSearchFolderId", path.id);
                  setFolder(path);
                }}
              >
                {path.name}
              </a>
            </React.Fragment>
          );
        })}
        {/*
                设置入口：
                1、文件列表-更多-设置；2、导航标题后方编辑按钮，点击后弹出设置弹窗。
                第一级文件夹可编辑内容：名称、描述、管理协作者。
                子文件夹可编辑内容只有名称，没有描述和协作者。
                一级文件夹可以编辑
                权限规则如下： 
                    文件夹的编辑/设置权限 与协作者权限关联。
                    协作者权限为可编辑时，可修改文件夹名称、描述。
                    协作者权限为仅查看时，只可查看文件夹详情，不可修改。
                */}
        {/* {paths[1]?.isRoot && paths[1]?.permissionType === permissionFileType.readWrite && (
                    <div className="joyspace-breadcrumb-title-edit">
                        <Icon type="iconic_editor" />
                    </div>
                )} */}
        {/* {paths[paths.length - 1]?.isRoot &&
                    paths[paths.length - 1]?.permissionsType !==
                        getJoySpaceReadOnlyPermission() && (
                        <Tooltip placement="top" title="设置文件夹名称和描述">
                            <div
                                className={
                                    disabled
                                        ? 'joyspace-breadcrumb-title-edit joyspace-breadcrumb-title-edit_icon'
                                        : 'joyspace-breadcrumb-title-edit'
                                }
                                onClick={() => {
                                    if (disabled) {
                                        return;
                                    }
                                    const item: any = paths[paths.length - 1] || {};
                                    // console.log(item, 'itemitemitemitemitem', paths[paths.length - 1]);
                                    openFolderModal({
                                        id: paths[paths.length - 1].id,
                                        isModalVisible: true,
                                        title: '设置文件夹',
                                        name: item.name,
                                        description: item.description,
                                        permissionsType: item.permissionsType,
                                        isRoot: true,
                                        folderType: folderTypeEnum.GROUP,
                                        isOpenFolder:
                                            item.open === 2
                                                ? OpenFolderStatus.OPEN
                                                : OpenFolderStatus.CLOSE,
                                        onOk: setFolderTitle,
                                    });
                                    events.emit('onShowFolderDesc', item.description);
                                }}
                            >
                                <Icon type="iconic_editor" />
                            </div>
                        </Tooltip>
                    )} */}
      </div>
      {/* 一级文件夹描述 tips: 我的文件不算 */}
      {/* {paths[paths.length - 1]?.isRoot && paths[paths.length - 1]?.description && (
                <div className="joyspace-breadcrumb-file-desc">
                    {paths[paths.length - 1]?.description || ''}
                </div>
            )} */}
    </div>
  ) : null;
}
function mapStateToProps({ joyspace }: { joyspace: JoyspaceState }) {
  return {
    folderInfoMap: joyspace.folderInfoMap,
    _filterInfo: joyspace.filterInfo
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    changeFolderInfoById(data: any) {
      return dispatch({ type: "joyspace/changeFolderInfoById", payload: { ...data } });
    },
    addFolderInfo(data: any) {
      return dispatch({ type: "joyspace/addFolderInfo", payload: { ...data } });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(SpaceCategoriesPaths);
